<!--  -->
<template>
  <div class="map-tools">
    <n-popover :overlap="overlap" :to="false" :delay="0" trigger="hover">
      <template #trigger>
        <span class="img-btn" @click="clickEvent('地图复位')"></span>
      </template>
      <span class="large-text">地图复位</span>
    </n-popover>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Bus from '@/config/Bus'
import { useMainStore } from '@/store/main'
import mapService from '@/utils/mapServices.js'
import pinia from '@/store/index'
import { Api } from '@/api/publicApi'

const api = new Api()
const mainStore = useMainStore(pinia)
const overlap = ref(false)
const tilt = ref(false)

const test = () => {
  // console.log(0)
  // const xx = {
  //   id: 'LJHSZ118GKJ1',
  //   category: 'ylz',
  //   jd: 105.978,
  //   wd: 29.224,
  // }
  // Bus.emit('showModal', {
  //   data: xx,
  //   modalType: '测试',
  // })
}

const clickEvent = async (val) => {
  switch (val) {
    case '数字孪生':
      mainStore.changeCustomer(true)
      mainStore.$patch({
        topMenu: 'smart_supervision',
        currentLeftMenu: '',
        leftMenu: {},
      })
      // eslint-disable-next-line no-undef
      ue4('CameraSwitch', {
        Id: 'Gis',
        Type: 1,
      })
      break
    case '水质反演':
      if (mapService.getLayer('UAVPoint')) {
        mapService.removeLayer('UAVPoint')
      } else {
        const poi = []
        const pointData = []
        pointData.push({
          coordinates: [106.04803, 29.41383],
          properties: { id: 2, category: 'wrj', modalType: '无人机巡河' },
        })
        pointData.push({
          coordinates: [106.0627416512523, 29.40369319826789],
          properties: { id: 3, category: 'wrj', modalType: '无人机巡河' },
        })
        poi.push({
          Id: 2,
          Label: '无人机',
          Coordinate: { X: 106.05244, Y: 29.41134, Z: 10 },
          Icon: '转移路线',
          Style: 'Icon',
          EleType: 3,
          Args: JSON.stringify({
            layer: '无人机',
            data: { id: 2, category: 'wrj' },
            modalType: '无人机',
          }),
          Group: '无人机',
          VisibleRange: '0,100000',
          Space: 1,
          Title: 2,
        })
        await mapService.addPointsLayer('UAVPoint', pointData, 'UAV', 0.9, 'center')
      }
      break
    case '三维城市':
      mainStore.changeCustomer(false)
      mapService.flyTo({
        center: [105.89845, 29.34622],
        zoom: 16.5,
        pitch: 48.999999999999986,
      })
      break
    case '水旱灾害防御':
      window.location.href = 'https://183.66.101.109:20010/#/fddDefense/homePage/home'
      break
    case '地图复位':
      mapService.reset()
      break
    default:
      break
  }
}

onMounted(() => {
  setTimeout(() => {
    // eslint-disable-next-line no-undef
    ue4('EnvironmentVersion', {}, (version) => {
      tilt.value = true
    })
  }, 1000)
})
</script>

<style lang="scss" scoped>
.map-tools {
  pointer-events: auto;
  position: absolute;
  bottom: 0px;
  display: flex;
  z-index: 1000;
  .disable {
    cursor: no-drop !important;
  }
  // flex-direction: column;
  .img-btn {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 0 5px;
    cursor: pointer;
    &:nth-of-type(1) {
      background-image: url('@/assets/img/map/数字孪生.png');
    }
    &:nth-of-type(2) {
      background-image: url('@/assets/img/map/三维城市.png');
    }
    &:nth-of-type(3) {
      background-image: url('@/assets/img/map/水质反演.png');
    }
    &:nth-of-type(4) {
      background-image: url('@/assets/img/map/水旱灾害防御.png');
    }
    &:nth-of-type(5) {
      background-image: url('@/assets/img/map/地图复位.png');
    }
  }
  :deep(.n-popover) {
    background: #ffffff;
    padding: 5px 6px !important;
    font-size: 12px;
    line-height: 12px;
    .n-popover__content {
      .large-text {
        color: #000000;
      }
    }
    .n-popover-arrow-wrapper {
      .n-popover-arrow {
        background: #ffffff;
      }
    }
  }
}
</style>
